import { Box, Grid, Typography } from '@mui/material';

import { AdminPanelSettings } from '@mui/icons-material';
import InitialSetup, { InitialSetUpProvider } from '@pages/initial-setup';
import ComingSoon from '@shared/partials/coming-soon';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getColor } from '../../assets/theme';
import ModuleCard from '../../components/ui/module-card';
import useDisclosure from '../../hooks/useDisclosure';
import useDriver from '../../hooks/useDriver';
import useToast from '../../hooks/useToast';
import { Module } from '../../interfaces/module.interface';
import { useAppSelector } from '../../store';
import { setGuideState } from '../../store/slices/guide.slice';
import {
  ModuleTypes,
  setActiveProperties,
} from '../../store/slices/property.slice';
import { moduleArr } from '../../utils/module-arr';
import { useNavigate } from 'react-router-dom';
import {
  selectHasBO,
  selectHasOnlyPOS,
  selectProperty,
} from '@store/selector/property.selector';

//
// MODULE SELECTOR
//

const Dashboard = ({ component }: { component?: boolean }) => {
  const navigate = useNavigate();

  const { bgColor } = getColor();

  const comingSoonDisclosure = useDisclosure();

  const [moduleState, setModuleState] = useState(moduleArr);

  const hasBO = useAppSelector(selectHasBO);
  const hasOnlyPOS = useAppSelector(selectHasOnlyPOS);
  const selectedProperty = useAppSelector(selectProperty);

  const properties = useAppSelector((state) => state.properties.properties);

  const { toast } = useToast();

  const dispatch = useDispatch();

  const filterModule = (
    selectedModules: ModuleTypes[],
    isAllProperties?: boolean,
  ) => {
    if (!selectedModules.length) return;

    const data = moduleArr
      .map((property) => {
        const currentModule = selectedModules?.find(
          (item) => item.Module.Code === property.code,
        );
        const isActive =
          property.isActive && (currentModule?.Module.isActive ?? false);

        return {
          ...currentModule?.Module,
          ...property,
          isActive,
          link: property?.link + '/dashboard',
        };
      })
      ?.sort((a: any, b: any) => {
        if (a.isActive && !b.isActive) {
          return -1; // a should come before b
        } else if (!a.isActive && b.isActive) {
          return 1; // b should come before a
        } else {
          return 0; // no change in order
        }
      });

    const propertiesWithCode = moduleArr.map((property) => {
      const isActive =
        property.isActive &&
        (selectedModules?.find((item) => item.Module.Code === property.code)
          ?.Module.isActive ??
          false);

      return {
        link: property?.link,
        isActive,
        disableOnAllProperty: property?.disableOnAllProperty && isAllProperties,
      };
    });

    dispatch(setActiveProperties(propertiesWithCode));
    setModuleState(data);
  };

  useEffect(() => {
    const selectedPropertyValue = selectedProperty?.value;
    if (selectedPropertyValue == 'All Properties') {
      const selectedModules: ModuleTypes[] = properties
        .map((property) => {
          return property?.userData?.Modules;
        })
        .flat()
        .filter((modules) => modules != null) as ModuleTypes[];

      filterModule(selectedModules ?? [], true);
    } else if (selectedPropertyValue != null) {
      const selectedModules = properties.find(
        (property) => property.propertyID == selectedPropertyValue,
      )?.userData?.Modules;
      filterModule(selectedModules ?? []);
    } else {
      setModuleState(moduleArr?.map((item) => ({ ...item, isActive: false })));
    }
  }, [selectedProperty, properties]);

  // useLayoutEffect(() => {
  // closeSnackbar(); // need to remove due to force closing the maintenance mode toast message
  // }, []);

  // Initial Module Card Guide

  const { driver, value, defaultConfig } = useDriver();
  const guideDisclosure = useDisclosure();

  useEffect(() => {
    if (!value.moduleSelector && properties && !component) {
      // guideDisclosure.onOpen();
      const driverObj = driver({
        ...defaultConfig,
        steps: [
          {
            element: '.property-selector',
            popover: { title: 'Title', description: 'Description' },
          },
          {
            element: '#guide',
            popover: { title: 'Title', description: 'Description' },
          },
          {
            element: '#module_card-icon_question',
            popover: { title: 'Title', description: 'Description' },
          },
          {
            element: '#module_card-icon_info',
            popover: { title: 'Title', description: 'Description' },
          },
          {
            element: '#module_card-icon_redirect',
            popover: { title: 'Title', description: 'Description' },
          },
        ],
        onDestroyed: () => {
          dispatch(setGuideState({ moduleSelector: true }));
          guideDisclosure.onClose();
        },
      });
      console.log(driverObj);
      // driverObj.drive();
    }
  }, []);

  useLayoutEffect(() => {
    if (hasOnlyPOS && !hasBO) {
      navigate('/point-of-sale');
    }
  }, []);

  return (
    <>
      {/* <DialogLoading {...{ isLoading }} /> */}
      <Typography variant='h6' fontWeight={600} pb={{ xs: 4, md: 3, xl: 2 }}>
        Modules
      </Typography>
      <InitialSetUpProvider>
        <InitialSetup />
        <Grid
          container
          spacing={2}
          sx={{ paddingTop: '10px', position: 'relative' }}
        >
          {(!properties ||
            !selectedProperty ||
            !selectedProperty?.value ||
            !selectedProperty?.label) && (
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                bottom: 0,
                right: 0,
                left: 0,
                zIndex: 2,
                opacity: 0.5,
                bgcolor: bgColor,
              }}
              onClick={() =>
                toast({
                  message: 'Please Select Property',
                  severity: 'warning',
                })
              }
            />
          )}
          {guideDisclosure.isOpen && (
            <ModuleCard
              guide
              module={{
                code: 'AD-N/A',
                title: 'Guide',
                link: '/',
                icon: AdminPanelSettings,
                disabledIcon: AdminPanelSettings,
                isActive: true,
                sidebar: [],
                description: `Sample description`,
              }}
              disclosure={comingSoonDisclosure}
            />
          )}
          {moduleState.map((module: Module, i: number) => {
            if (module.title === 'BO') return null;
            return (
              <ModuleCard
                module={module}
                key={i}
                disclosure={comingSoonDisclosure}
              />
            );
          })}
        </Grid>
      </InitialSetUpProvider>
      <ComingSoon {...{ disclosure: comingSoonDisclosure }} />
    </>
  );
};

export default Dashboard;
